<div class="d-flex justify-content-between align-item-center instanceDataHeader">
    <div class="instanceHeader">
        <h2 *ngIf="!demoMode" mat-dialog-title class="dialog-title">
            <span class="mr-1" [textContent]="name"></span>
            <mat-icon class="mr-2 ml-2">double_arrow</mat-icon>
            <span class="-pl-1">
                <span [textContent]="'Run #' + clearanceRunNumber"></span>
                <ng-container *ngIf="(stateName | async)?.length > 0">
                    <span [textContent]="'/ ' + (stateName | async)"></span>
                </ng-container>
            </span>
            <mat-icon class="mr-2 ml-2">double_arrow</mat-icon>
            <span class="mr-1" [textContent]="selectedEntity.displayName"></span>
        </h2>
        <h2 *ngIf="demoMode" mat-dialog-title class="dialog-title">
            Selected records of entity:
            <strong [textContent]="this.selectedEntity.displayName"></strong>
        </h2>
    </div>
    <div class="loadingContainer" *ngIf="!demoMode && (loadingStatus | async)">
        <app-dots-loader [showLoading]="true"></app-dots-loader>
    </div>
    <mat-icon (click)="closeModal()">close</mat-icon>
</div>
<mat-dialog-content [ngClass]="{ 'demo-mat-dialog-content': demoMode }">
    <div class="dialog-main-container" *transloco="let translate">
        <ng-container *ngIf="!demoMode">
            <app-instance-data-primary-entity></app-instance-data-primary-entity>
        </ng-container>
        <div class="row body-container">
            <div class="left-menu" *ngIf="!demoMode">
                <app-instance-data-entities></app-instance-data-entities>
            </div>
            <div class="right-content" *transloco="let translate">

                <div class="instance-data-content row">
                    <div class="source col-6 primary" *ngIf="isConfigurationLoaded">
                        <div class="sourceHeader">
                            <div class="flex items-center gap-7">
                                <span class="sourceText" [textContent]="source1 + ' :'"></span>
                                <!-- Export Dropdown -->
                                <button *ngIf="isMisMatchGroup" mat-stroked-button [matMenuTriggerFor]="exportMenuSource1">
                                    <mat-icon>download</mat-icon>
                                    Export
                                    <mat-icon>arrow_drop_down</mat-icon>
                                </button>
                                <mat-menu #exportMenuSource1="matMenu" xPosition="before">
                                    <button mat-menu-item (click)="exportTableData('source1', 'selected')">
                                        <mat-icon>download</mat-icon>
                                        <span>Export Selected Items</span>
                                    </button>
                                    <button mat-menu-item (click)="exportTableData('source1', 'all')">
                                        <mat-icon>download</mat-icon>
                                        <span>Export All Items</span>
                                    </button>
                                </mat-menu>
                            </div>
                            <div class="flex items-center gap-4">
                                <div class="w-[35%]">
                                    <mat-form-field class="font-bold">
                                        <mat-label *ngIf="!selectedTable1Id" class="!font-bold !text-black">
                                            {{ translate('Select Column for Total') }}
                                        </mat-label>
                                        <mat-select
                                                    [(value)]="selectedTable1Id"
                                                    (selectionChange)="onSelectedColumnChange('source1', $event.value)"
                                                    [title]="selectedTable1Id || ''">
                                            <mat-option [value]="null">
                                                <em>
                                                    --
                                                    <span [textContent]="translate('Please select')"></span>
                                                    --
                                                </em>
                                            </mat-option>
                                            <mat-option *ngFor="let table of table1NumericFields" [value]="table.id">
                                                {{ table.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <span
                                      class="sourceText !relative left-[10px]"
                                      [textContent]="translate('Total') + ' : ' + table1_totalCount"></span>
                            </div>
                        </div>
                        <app-gst-instance-data-table
                            [debounce]="1000"
                            [demoMode]="demoMode"
                            [isMisMatchGroup]="isMisMatchGroup"
                            [templateId]="'source1'"
                            [data]="source1tableData"
                            [allTableColumns]="source1_allColumns"
                            [selectedColumns]="source1_selectedColumns"
                            [columnSearchRequired]="!demoMode && true"
                            (clickedRecord)="clickedRecord($event)"
                            (onSearchEvent)="onColumnSearch($event, isMisMatchGroup ? 'source1' : undefined)"
                            (onColumnChange)="onColumnChangeFromTable($event)"
                            [useUserPreferences]="true"
                            (onResetPreferences)="resetColumnPreferences('source1')"></app-gst-instance-data-table>
                        <mat-paginator
                            *ngIf="isMisMatchGroup"
                            [hidden]="demoMode || source1Pagination?.index === undefined || !isConfigurationLoaded || !isMisMatchGroup"
                            [pageIndex]="source1Pagination.index"
                            [pageSizeOptions]="[5, 10, 20, 50]"
                            [length]="source1Pagination.count"
                            [pageSize]="source1Pagination.size"
                            showFirstLastButtons="false"
                            (page)="changedPage($event, 'source1')"></mat-paginator>
                    </div>
                    <div class="source col-6 secondary last" *ngIf="isConfigurationLoaded">
                        <div class="sourceHeader">
                            <div class="flex items-center gap-7">
                                <span class="sourceText" [textContent]="source2 + ' :'"></span>
                                <!-- Export Dropdown -->
                                <button *ngIf="isMisMatchGroup" mat-stroked-button [matMenuTriggerFor]="exportMenuSource2">
                                    <mat-icon>download</mat-icon>
                                    Export
                                    <mat-icon>arrow_drop_down</mat-icon>
                                </button>
                                <mat-menu #exportMenuSource2="matMenu" xPosition="before">
                                    <button mat-menu-item (click)="exportTableData('source2', 'selected')">
                                        <mat-icon>download</mat-icon>
                                        <span>Export Selected Items</span>
                                    </button>
                                    <button mat-menu-item (click)="exportTableData('source2', 'all')">
                                        <mat-icon>download</mat-icon>
                                        <span>Export All Items</span>
                                    </button>
                                </mat-menu>
                            </div>
                            <div class="flex items-center gap-4">
                                <div class="w-[30%]">
                                    <mat-form-field class="font-bold">
                                        <mat-label *ngIf="!selectedTable2Id" class="!font-bold !text-black">
                                            {{ translate('Select Column for Total') }}
                                        </mat-label>
                                        <mat-select
                                                    [(value)]="selectedTable2Id"
                                                    (selectionChange)="onSelectedColumnChange('source2', $event.value)"
                                                    [title]="selectedTable2Id || ''">
                                            <mat-option [value]="null">
                                                <em>
                                                    --
                                                    <span [textContent]="translate('Please select')"></span>
                                                    --
                                                </em>
                                            </mat-option>
                                            <mat-option *ngFor="let table of table2NumericFields" [value]="table.id">
                                                {{ table.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <span
                                    class="sourceText !relative left-[10px]"
                                    [textContent]="translate('Total') + ' : ' + table2_totalCount"></span>

                            </div>
                        </div>
                        <app-gst-instance-data-table
                            [debounce]="1000"
                            [demoMode]="demoMode"
                            [isMisMatchGroup]="isMisMatchGroup"
                            [templateId]="'source2'"
                            [data]="source2tableData"
                            [allTableColumns]="source2_allColumns"
                            [selectedColumns]="source2_selectedColumns"
                            [columnSearchRequired]="!demoMode && true"
                            (clickedRecord)="clickedRecord($event)"
                            (onSearchEvent)="onColumnSearch($event, isMisMatchGroup ? 'source2' : undefined)"
                            (onColumnChange)="onColumnChangeFromTable($event)"
                            [useUserPreferences]="true"
                            (onResetPreferences)="resetColumnPreferences('source2')"></app-gst-instance-data-table>
                        <mat-paginator
                            *ngIf="isMisMatchGroup"
                            [hidden]="demoMode || source2Pagination?.index === undefined || !isConfigurationLoaded || !isMisMatchGroup"
                            [pageIndex]="source2Pagination.index"
                            [pageSizeOptions]="[5, 10, 20, 50]"
                            [length]="source2Pagination.count"
                            [pageSize]="source2Pagination.size"
                            showFirstLastButtons="false"
                            (page)="changedPage($event, 'source2')"></mat-paginator>
                    </div>
                    <mat-paginator
                        *ngIf="!isMisMatchGroup"
                        [hidden]="demoMode || source1Pagination?.index === undefined || !isConfigurationLoaded"
                        [pageIndex]="source1Pagination.index"
                        [pageSizeOptions]="[5, 10, 20, 50, 100, 500]"
                        [length]="dataLength"
                        [pageSize]="source1Pagination.size"
                        showFirstLastButtons="false"
                        (page)="changedPage($event)"></mat-paginator>
                </div>
            </div>
            <div class="entityActionsContainer right" [hidden]="demoMode || selectedRecordsCount === 0 || !canShowMovableEntities">
                <material-button
                    [classList]="['right-3']"
                    [text]="isMisMatchGroup ? 'Confirm Match' : 'Confirm Mismatch'"
                    [disabled]="!moveToGroup || (isMisMatchGroup ? selectedRecordsCount !== 2 : false)"
                    (buttonClicked)="initiateChange()"></material-button>
                <material-button
                    [buttonType]="'raised'"
                    [color]="'primary'"
                    [text]="'Show Selected'"
                    (buttonClicked)="$event.stopPropagation(); showSelectedRecords()"></material-button>
            </div>
        </div>
    </div>
</mat-dialog-content>
